<template>
  <langham-template
    :portal="portal"
    :connection_data="connection_data"
    :load_states="load_states"
    :error="error"
    :config="config"
    v-on:emitRegistrationMethodData="$emit('emitRegistrationMethodData', $event)"
  />
</template>

<script>
import LanghamTemplate from '@/components/custom/_langham2026/LanghamTemplate';
import bannerDesktop from '@/components/custom/_langham2026/assets/img/LanghamEatonDCBanner.png';
import bannerMobile from '@/components/custom/_langham2026/assets/img/420x239.jpg';

export default {
  name: 'custom_template',
  props: ['portal', 'connection_data', 'load_states', 'error'],
  components: { LanghamTemplate },
  data() {
    return {
      config: {
        propertyName: 'Eaton Hotel DC',
        formVariant: 'standard',
        bannerDesktop,
        bannerMobile,
        chatUrl: 'http://chat.langhamhotels.com/the-langham-dc-WEB',
      },
    };
  },
};
</script>
